var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"100%","height":"200","viewBox":"0 0 1000 100","preserveAspectRatio":"none"}},[_c('polyline',{attrs:{"fill":"#203642","stroke":"#94b9cb","stoke-width":"2","points":_vm.pointsStr}})])}
var staticRenderFns = []

export { render, staticRenderFns }